export default "__VITE_ASSET__DYPpfVcE__"